var _g, _g2, _g3, _g4, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArDrodown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_7834_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6981 1.37109H3.06846C1.95008 1.37109 1.04346 2.27772 1.04346 3.39609V15.0258C1.04346 16.1442 1.95008 17.0508 3.06846 17.0508H14.6981C15.8165 17.0508 16.7231 16.1442 16.7231 15.0258V3.39609C16.7231 2.27772 15.8165 1.37109 14.6981 1.37109Z",
    fill: "url(#paint0_linear_7834_403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6981 1.37109H3.06846C1.95008 1.37109 1.04346 2.27772 1.04346 3.39609V15.0258C1.04346 16.1442 1.95008 17.0508 3.06846 17.0508H14.6981C15.8165 17.0508 16.7231 16.1442 16.7231 15.0258V3.39609C16.7231 2.27772 15.8165 1.37109 14.6981 1.37109Z",
    fill: "url(#paint1_radial_7834_403)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7834_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7744 2.77734V15.6445",
    stroke: "url(#paint2_linear_7834_403)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7834_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99268 2.39062H15.2439",
    stroke: "url(#paint3_linear_7834_403)",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7834_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4305 5.96043L12.518 4.21218C12.3841 4.07774 12.1501 4.1773 12.1445 4.37024V5.08349C12.1448 5.11046 12.1397 5.13722 12.1295 5.1622C12.1193 5.18718 12.1043 5.20987 12.0852 5.22894C12.0661 5.24801 12.0434 5.26309 12.0185 5.27327C11.9935 5.28345 11.9667 5.28854 11.9397 5.28824H6.39012C4.66494 5.29386 3.25587 6.68549 3.25587 8.40449V10.1775C3.25539 10.217 3.26647 10.2558 3.28774 10.289C3.30901 10.3223 3.33956 10.3486 3.3756 10.3648C3.41165 10.3809 3.45164 10.3862 3.49063 10.3799C3.52962 10.3736 3.56592 10.356 3.59506 10.3294L4.85787 9.17174C4.87814 9.15433 4.89441 9.13276 4.90558 9.10849C4.91674 9.08422 4.92253 9.05783 4.92256 9.03111V8.41068C4.92256 8.01981 5.07783 7.64496 5.35421 7.36858C5.63059 7.0922 6.00545 6.93693 6.39631 6.93693L11.9448 6.95493C12.0562 6.95493 12.1496 7.0483 12.1496 7.15911V7.87293C12.1496 8.06586 12.3774 8.17105 12.518 8.03605L14.4305 6.28218C14.4538 6.26238 14.4726 6.23773 14.4855 6.20995C14.4983 6.18217 14.505 6.15192 14.505 6.1213C14.505 6.09069 14.4983 6.06044 14.4855 6.03266C14.4726 6.00488 14.4538 5.98023 14.4305 5.96043ZM3.33237 12.459L5.24487 14.2072C5.37931 14.3422 5.61275 14.2427 5.61894 14.0497V13.3359C5.61894 13.2246 5.70669 13.1312 5.82369 13.1312H11.3727C13.0974 13.1256 14.5064 11.7334 14.5064 10.0149V8.2633C14.5069 8.22381 14.4958 8.18503 14.4746 8.15175C14.4533 8.11848 14.4228 8.09214 14.3867 8.076C14.3507 8.05986 14.3107 8.05461 14.2717 8.06091C14.2327 8.0672 14.1964 8.08476 14.1672 8.11143L12.9044 9.26905C12.8843 9.28651 12.8681 9.30811 12.857 9.33237C12.846 9.35664 12.8403 9.38301 12.8403 9.40968V10.0087C12.8403 10.2023 12.8022 10.3939 12.7281 10.5727C12.6541 10.7515 12.5455 10.914 12.4087 11.0508C12.2718 11.1877 12.1093 11.2962 11.9305 11.3703C11.7517 11.4444 11.5601 11.4825 11.3666 11.4825L5.8175 11.4645C5.76347 11.4636 5.71189 11.4418 5.67368 11.4036C5.63547 11.3653 5.61362 11.3138 5.61275 11.2597V10.5465C5.61275 10.3536 5.38494 10.2484 5.24487 10.3834L3.33237 12.1372C3.30912 12.157 3.29045 12.1817 3.27764 12.2094C3.26483 12.2371 3.2582 12.2673 3.2582 12.2978C3.2582 12.3284 3.26483 12.3586 3.27764 12.3863C3.29045 12.414 3.30912 12.4386 3.33237 12.4584",
    fill: "#579FFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_7834_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4305 5.96043L12.518 4.21218C12.3841 4.07774 12.1501 4.1773 12.1445 4.37024V5.08349C12.1448 5.11046 12.1397 5.13722 12.1295 5.1622C12.1193 5.18718 12.1043 5.20987 12.0852 5.22894C12.0661 5.24801 12.0434 5.26309 12.0185 5.27327C11.9935 5.28345 11.9667 5.28854 11.9397 5.28824H6.39012C4.66494 5.29386 3.25587 6.68549 3.25587 8.40449V10.1775C3.25539 10.217 3.26647 10.2558 3.28774 10.289C3.30901 10.3223 3.33956 10.3486 3.3756 10.3648C3.41165 10.3809 3.45164 10.3862 3.49063 10.3799C3.52962 10.3736 3.56592 10.356 3.59506 10.3294L4.85787 9.17174C4.87814 9.15433 4.89441 9.13276 4.90558 9.10849C4.91674 9.08422 4.92253 9.05783 4.92256 9.03111V8.41068C4.92256 8.01981 5.07783 7.64496 5.35421 7.36858C5.63059 7.0922 6.00545 6.93693 6.39631 6.93693L11.9448 6.95493C12.0562 6.95493 12.1496 7.0483 12.1496 7.15911V7.87293C12.1496 8.06586 12.3774 8.17105 12.518 8.03605L14.4305 6.28218C14.4538 6.26238 14.4726 6.23773 14.4855 6.20995C14.4983 6.18217 14.505 6.15192 14.505 6.1213C14.505 6.09069 14.4983 6.06044 14.4855 6.03266C14.4726 6.00488 14.4538 5.98023 14.4305 5.96043ZM3.33237 12.459L5.24487 14.2072C5.37931 14.3422 5.61275 14.2427 5.61894 14.0497V13.3359C5.61894 13.2246 5.70669 13.1312 5.82369 13.1312H11.3727C13.0974 13.1256 14.5064 11.7334 14.5064 10.0149V8.2633C14.5069 8.22381 14.4958 8.18503 14.4746 8.15175C14.4533 8.11848 14.4228 8.09214 14.3867 8.076C14.3507 8.05986 14.3107 8.05461 14.2717 8.06091C14.2327 8.0672 14.1964 8.08476 14.1672 8.11143L12.9044 9.26905C12.8843 9.28651 12.8681 9.30811 12.857 9.33237C12.846 9.35664 12.8403 9.38301 12.8403 9.40968V10.0087C12.8403 10.2023 12.8022 10.3939 12.7281 10.5727C12.6541 10.7515 12.5455 10.914 12.4087 11.0508C12.2718 11.1877 12.1093 11.2962 11.9305 11.3703C11.7517 11.4444 11.5601 11.4825 11.3666 11.4825L5.8175 11.4645C5.76347 11.4636 5.71189 11.4418 5.67368 11.4036C5.63547 11.3653 5.61362 11.3138 5.61275 11.2597V10.5465C5.61275 10.3536 5.38494 10.2484 5.24487 10.3834L3.33237 12.1372C3.30912 12.157 3.29045 12.1817 3.27764 12.2094C3.26483 12.2371 3.2582 12.2673 3.2582 12.2978C3.2582 12.3284 3.26483 12.3586 3.27764 12.3863C3.29045 12.414 3.30912 12.4386 3.33237 12.4584",
    fill: "#FCF2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_7834_403",
    x: 1.04346,
    y: 0.871094,
    width: 16.1797,
    height: 16.1797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.470588 0 0 0 0 0.843137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7834_403"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.34902 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7834_403",
    result: "effect2_innerShadow_7834_403"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7834_403",
    x: 14.3994,
    y: 1.40234,
    width: 2.75,
    height: 15.6172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7834_403"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7834_403",
    x: 1.61768,
    y: 1.01562,
    width: 15.0015,
    height: 2.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7834_403"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7834_403",
    x: 2.75586,
    y: 3.65039,
    width: 12.2505,
    height: 11.1191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_7834_403"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_7834_403",
    x: 2.95586,
    y: 3.95039,
    width: 11.7505,
    height: 10.6191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.3,
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.819608 0 0 0 0 0.941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_7834_403"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.988235 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_7834_403",
    result: "effect2_innerShadow_7834_403"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7834_403",
    x1: 8.88358,
    y1: 3.38147,
    x2: 8.88358,
    y2: 22.0863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4878DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7834_403",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4755 2.54841) rotate(136.771) scale(1.20625 1.40887)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BD7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7834_403",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FD9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#639DF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7834_403",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DB6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArDrodown);
export default __webpack_public_path__ + "static/media/arDrodown.27fc254126be0404b848f937381516b6.svg";
export { ForwardRef as ReactComponent };